import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import PasswordInput from "@/components/PasswordInput";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ChangePassword() {
  const { refresh, user, loading } = useAuth();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && !user) navigate("/login");

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Las contraseñas no coinciden"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      const u = await refresh();
      toast.success("Contraseña actualizada");
      const dest = u?.role === "assistant" || u?.role === "doctor" ? "/panel" : "/buscar";
      navigate(dest);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-6">
        <div className="rounded-2xl border border-[#E2E8F0] bg-white p-8">
          <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-full bg-sky-50 text-[#0284C7]">
            <KeyRound className="h-5 w-5" />
          </div>
          <h1 className="text-2xl font-extrabold tracking-tight text-slate-900">Cambia tu contraseña</h1>
          <p className="mt-1 text-sm font-semibold text-slate-500">
            Por seguridad debes definir una nueva contraseña antes de continuar.
          </p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">Nueva contraseña</Label>
              <PasswordInput required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5 rounded-xl border-[#E2E8F0]" data-testid="new-password-input" />
            </div>
            <div>
              <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">Confirmar contraseña</Label>
              <PasswordInput required minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-1.5 rounded-xl border-[#E2E8F0]" data-testid="new-password2-input" />
            </div>
            <Button type="submit" disabled={busy} className="w-full rounded-full bg-[#0284C7] font-bold hover:bg-[#0369a1]" data-testid="change-password-submit">
              {busy ? "Guardando…" : "Guardar contraseña"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
